import { DeliveryLocationTypesTable } from '@/components/features/delivery-location-type'

export const DeliveryLocationTypes = () => {
    return <DeliveryLocationTypesTable />
}
